// File: src/utils/neutralSocket.js
import { io } from "socket.io-client";

let socket;

/* ---- auth helpers ---- */
function getCreds() {
  const auth = JSON.parse(localStorage.getItem("tribe_auth") || "{}");
  const token =
    auth?.token ||
    localStorage.getItem("accessToken") ||
    localStorage.getItem("refreshToken") ||
    "";
  const userId =
    auth?.uid ||
    auth?.userId ||
    auth?.user?._id ||
    localStorage.getItem("userId") ||
    "";
  return { token, userId };
}

function joinUserRoomSafe(sock) {
  try {
    const { userId } = getCreds();
    if (userId && sock?.connected) {
      sock.emit("joinUserRoom", String(userId));
    }
  } catch {}
}

export function refreshNeutralSocketAuth({ reconnectIfNeeded = true } = {}) {
  if (!socket) return;
  const { token } = getCreds();
  socket.auth = { token };
  if (reconnectIfNeeded && !socket.connected) {
    try { socket.connect(); } catch {}
  }
}

export function getNeutralSocket() {
  if (socket?.connected) return socket;
  if (socket && !socket.connected) {
    refreshNeutralSocketAuth();
    return socket;
  }

  const { token } = getCreds();

  socket = io(process.env.REACT_APP_API_URL, {
    transports: ["websocket", "polling"],
    withCredentials: true,
    auth: { token },
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 300,
    reconnectionDelayMax: 3000,
    timeout: 8000,
    pingInterval: 12000,
    pingTimeout: 8000,
  });

  socket.on("connect", () => {
    refreshNeutralSocketAuth({ reconnectIfNeeded: false });
    joinUserRoomSafe(socket);
  });

  socket.on("reconnect_attempt", () => {
    refreshNeutralSocketAuth({ reconnectIfNeeded: false });
  });

  // reflect token/user changes across tabs
  const onStorage = (e) => {
    if (!e) return;
    const keys = ["accessToken", "tribe_auth", "refreshToken", "userId"];
    if (!keys.includes(e.key)) return;
    refreshNeutralSocketAuth({ reconnectIfNeeded: false });
    joinUserRoomSafe(socket);
  };
  try { window.addEventListener("storage", onStorage); } catch {}

  return socket;
}
